import { PlayerManager } from "@manager/playerManager/PlayerManager";
import { PlayerState } from "../../api/model/playerState/PlayerState";
import { VintomError } from "../../api/model/error/VintomError";
import { PlayerActionState } from "../../api/model/playerState/PlayerActionState";
import { FullPlayerConfiguration } from "../../model/playerConfiguration/FullPlayerConfiguration";
import { injectable, unmanaged } from "inversify";
import { AnalyticsCollector } from "@manager/playerAnalytics/AnalyticsCollector";
import { I18n } from "../../i18n/i18n";
import { getI18n } from "../../utils/translations";
import { ConfigurationBuilder } from "@manager/configurationBuilder/ConfigurationBuilder";
import { PlayerSetupConfig } from "../../api/player/PlayerConfigTypes";
import { PlayerMusicManager } from "@manager/scenarioRunner/musicManager/PlayerSyncedMusicManager";
import { initializeClientHints } from "../../utils/ClientHints";

@injectable()
export abstract class BasePlayerManager implements PlayerManager {
  protected playerConfig: FullPlayerConfiguration;
  protected i18n: I18n;

  protected constructor(
    @unmanaged() protected analyticsCollector: AnalyticsCollector,
    @unmanaged() protected configBuilder: ConfigurationBuilder,
  ) {}

  async initialize(config: PlayerSetupConfig) {
    this.playerConfig = await this.configBuilder.build(config);
    this.i18n = getI18n();

    await initializeClientHints();
    this.initializeAnalytics();
  }

  getState(): PlayerState {
    return undefined;
  }

  moveToScenarioElement(id: string): void {}

  pause(): void {}

  performAction(ctaId: number, actionId: number, ...args: any[]): void {}

  play(): void {}

  prepareForRemove(): void {}

  registerOnAction(callback: (payload: PlayerActionState) => void): void {}

  registerOnError(callback: (error: VintomError) => void): void {}

  registerOnFinish(callback: (payload: PlayerState) => void): void {}

  registerOnPause(callback: (payload: PlayerState) => void): void {}

  registerOnPlay(callback: (payload: PlayerState) => void): void {}

  registerOnReady(callback: () => void): void {}

  replay(): void {}

  // TODO Bad code, to remove
  getMusicManager(): PlayerMusicManager {
    return undefined;
  }

  private initializeAnalytics() {
    this.analyticsCollector.initialize(
      this.playerConfig.code,
      this.playerConfig.videoDate,
      this.playerConfig.analyticsEndpoints,
      this.playerConfig.campaign,
      this.playerConfig.groupId,
    );
  }

  abstract run(): void;
}
